<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6250_4693)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.5459 7.39961L27.6368 7.39961C27.0845 7.39961 26.6368 6.95189 26.6368 6.39961C26.6368
        5.84732 27.0845 5.39961 27.6368 5.39961L29.5459 5.39961L29.5459 2.59961L2.45499 2.59961L2.45499
        5.39961L4.36408 5.39961C4.91636 5.39961 5.36408 5.84732 5.36408 6.39961C5.36408 6.95189 4.91636
        7.39961 4.36408 7.39961L2.45499 7.39961L2.45499 24.5996L4.36408 24.5996C4.91636 24.5996 5.36408
        25.0473 5.36408 25.5996C5.36408 26.1519 4.91636 26.5996 4.36408 26.5996L2.45499 26.5996L2.45499
        29.3996L29.5459 29.3996L29.5459 26.5996L27.6368 26.5996C27.0845 26.5996 26.6368 26.1519 26.6368
        25.5996C26.6368 25.0473 27.0845 24.5996 27.6368 24.5996L29.5459 24.5996L29.5459 7.39961ZM31.5459
        29.4396C31.5459 29.9303 31.3696 30.4178 31.0302 30.7911C30.688 31.1676 30.2023 31.3996 29.6732
        31.3996L2.32772 31.3996C1.79862 31.3996 1.31289 31.1676 0.970662 30.7911C0.631316 30.4178 0.454987
        29.9303 0.454987 29.4396L0.454988 2.55961C0.454988 2.06892 0.631317 1.58139 0.970663 1.20811C1.31289
        0.83166 1.79862 0.599608 2.32772 0.599608L29.6732 0.599609C30.2023 0.599609 30.688 0.831663 31.0302
        1.20811C31.3696 1.58139 31.5459 2.06892 31.5459 2.55961L31.5459 29.4396ZM24.2732 25.5996C24.2732
        26.1519 23.8255 26.5996 23.2732 26.5996L21.8041 26.5996C21.2518 26.5996 20.8041 26.1519 20.8041
        25.5996C20.8041 25.0473 21.2518 24.5996 21.8041 24.5996L23.2732 24.5996C23.8255 24.5996 24.2732
        25.0473 24.2732 25.5996ZM24.2586 6.39961C24.2586 6.95189 23.8109 7.39961 23.2586 7.39961L21.8186
        7.39961C21.2663 7.39961 20.8186 6.95189 20.8186 6.39961C20.8186 5.84732 21.2663 5.39961 21.8186
        5.39961L23.2586 5.39961C23.8109 5.39961 24.2586 5.84732 24.2586 6.39961ZM17.7277 25.6156C17.7277
        26.1679 17.28 26.6156 16.7277 26.6156L15.2877 26.6156C14.7354 26.6156 14.2877 26.1679 14.2877
        25.6156C14.2877 25.0633 14.7354 24.6156 15.2877 24.6156L16.7277 24.6156C17.28 24.6156 17.7277
        25.0633 17.7277 25.6156ZM17.7277 6.41561C17.7277 6.96789 17.28 7.41561 16.7277 7.41561L15.2877
        7.41561C14.7354 7.41561 14.2877 6.96789 14.2877 6.41561C14.2877 5.86332 14.7354 5.41561 15.2877
        5.41561L16.7277 5.41561C17.28 5.41561 17.7277 5.86332 17.7277 6.41561ZM11.1837 6.41561C11.1837
        6.96789 10.736 7.41561 10.1837 7.41561L8.72772 7.41561C8.17543 7.41561 7.72772 6.96789 7.72772
        6.41561C7.72772 5.86332 8.17543 5.41561 8.72772 5.41561L10.1837 5.41561C10.736 5.41561 11.1837
        5.86332 11.1837 6.41561ZM11.1677 25.5996C11.1677 26.1519 10.72 26.5996 10.1677 26.5996L8.72772
        26.5996C8.17543 26.5996 7.72772 26.1519 7.72772 25.5996C7.72772 25.0473 8.17543 24.5996 8.72772
        24.5996L10.1677 24.5996C10.72 24.5996 11.1677 25.0473 11.1677 25.5996Z"
      fill="white"
    />
    <path
      d="M20.5708 16.8575L13.5145 21.0913C12.848 21.4912 12 21.0111 12 20.2338L12 11.7662C12 10.9889 12.848 
        10.5088 13.5145 10.9087L20.5708 15.1425C21.2182 15.5309 21.2182 16.4691 20.5708 16.8575Z"
      fill="white"
    />
    </g>
    <defs>
    <clipPath id="clip0_6250_4693">
    <rect width="32" height="32" fill="white" transform="translate(32) rotate(90)"/>
    </clipPath>
    </defs>
  </svg>
</template>
